export default "__VITE_ASSET__CKKQYpLN__"